import { Observable } from 'rxjs'
import { filter, map, switchMap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { configurationOptionSelectors } from 'src/app/features/configuration-option/configuration-option.selectors'
import { environment } from 'src/environments/environment'
import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Store } from '@ngrx/store'
import { ConfigurationService } from '../../shared/services/configuration.service'
import { AppRoutesNS } from '../../app-routes.namespace'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'footer-component',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class FooterComponent implements OnInit {
  public footerBody$: Observable<SafeHtml>
  public primaryWhiteLogoUrl$: Observable<string>
  public bookingModuleConfig = environment.moduleConfigs.bookingModule

  public brandingConfig: any
  public appRoutesNS = AppRoutesNS
  constructor(
    private store: Store<AppState>,
    private sanitizer: DomSanitizer,
    public configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    this.brandingConfig = environment.branding

    this.primaryWhiteLogoUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'primary_white_logo_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) =>
          configOption?.value.length
            ? `${environment.staticAssetBaseUrl}${configOption?.value}`
            : ''
        )
      )

    this.footerBody$ = this.store
      .select(settingSelectors.selectById, 'language')
      .pipe(
        switchMap((language) => {
          return this.store
            .select(
              configurationOptionSelectors.selectByKey,
              `${language}_terms_conditions_footer`
            )
            .pipe(
              filter((configurationOption) => Boolean(configurationOption)),
              map((configurationOption) => {
                return this.sanitizer.bypassSecurityTrustHtml(
                  configurationOption?.value
                )
              })
            )
        })
      )
  }
  public getLandingPageRedirect(): string {
    return environment.moduleConfigs.authModule.afterLoginSuccessRedirect
  }
}
